import React from 'react';

export const InputPreview = ({ component, onClick, isSelected }) => {
  const { commonAttrs, specificAttrs } = component;
  
  const containerStyle = {
    padding: `${commonAttrs.paddingTop}px ${commonAttrs.paddingRight}px ${commonAttrs.paddingBottom}px ${commonAttrs.paddingLeft}px`,
    margin: `${commonAttrs.marginTop}px ${commonAttrs.marginRight}px ${commonAttrs.marginBottom}px ${commonAttrs.marginLeft}px`,
    cursor: 'pointer'
  };

  const labelStyle = {
    display: 'block',
    fontSize: '14px',
    fontWeight: '500',
    marginBottom: '4px',
    color: '#374151'
  };

  const inputStyle = {
    width: '100%',
    padding: '8px 12px',
    fontSize: '14px',
    border: isSelected ? '2px solid #3B82F6' : '1px solid #D1D5DB',
    borderRadius: '6px',
    outline: 'none',
    backgroundColor: specificAttrs.disabled ? '#F3F4F6' : '#FFFFFF'
  };

  return (
    <div style={containerStyle} onClick={onClick}>
      {specificAttrs.label && <label style={labelStyle}>{specificAttrs.label}</label>}
      <input
        type={specificAttrs.type || 'text'}
        placeholder={specificAttrs.placeholder}
        name={specificAttrs.name}
        required={specificAttrs.required}
        disabled={specificAttrs.disabled}
        style={inputStyle}
      />
    </div>
  );
};
